// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"~views/colors.css\"","easilBlack":"#2c2e2f","easilGrayXLight":"#D1D4D6","dropDownWrapper":"style_dropDownWrapper__21vmM"};